import React from "react";
import { useTranslation } from "react-i18next";

import { legalLockTranslationKeys } from "@utils/account-settings/account-lock";
import { Button } from "@components/buttons";
import { useFixBody } from "@state/hooks/shared";
import { isUserAuthenticated } from "@utils";

export default function LockInstructionsPopup({
	onClose,
	isInstructionPopupVisible,
}: {
	onClose: () => void;
	isInstructionPopupVisible: boolean;
}) {
	const { t } = useTranslation("account-lock");

	useFixBody(true, true);

	if (!isInstructionPopupVisible) {
		return null;
	}

	if (!isUserAuthenticated()) {
		return null;
	}

	return (
		<div className="popup">
			<div className="popup__card">
				<div className="popup__header">
					<div className="popup__title">
						{t<string>("HEADER.LOCK_BUTTON_LABEL")}
					</div>
					<Button
						onClick={onClose}
						className="btn--square btn--square--sml btn--primary--inverted popup__close"
						iconClassName="u-icon--tny u-icon--close u-color--text--secondary"
						iconOnly
					/>
				</div>
				<div className="popup__body">
					<ul className="list">
						<li>{t("HEADER.LOCK_INSTRUCTIONS")}</li>
						<li>
							{legalLockTranslationKeys
								.map((key) => t(key))
								.join(" ")}
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
